
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { authKey, GET_CONSIGNMENT_STATUS_LIST, GET_ASN_LIST, GET_STAKEHOLDER_CATEGORY, GET_ASN_CORRECTION_LIST, APPROVE_ASN_CORRECTION, REJECT_ASN_CORRECTION } from '../../../common/URLs';
import jwt from 'jwt-decode';
import { loaderService } from "../../../common/custom-loader/loader-service";
import moment from 'moment';
import { Container, Button, Box, TextField, Tooltip, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, CardContent, Grid, FormControl, InputLabel, Select, Tab } from '@mui/material'
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PIT_ROLES, PROD } from "../../../common/constants";
import { toast } from 'react-toastify';
import { ApproveIcon, CancelIcon, CloseIcon, EditIcon, SubmitIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";

function AsnCorrectionApproval() {

    const navigate = useNavigate();
    const { state } = useLocation();
    const [asnDetails, setAsnDetails] = useState([]);
    const [tabValue, setTabValue] = useState(state?.tabValue ? state?.tabValue : (getLocalStorageItem('role') === PIT_ROLES?.PitScmUser || getLocalStorageItem('role') === PIT_ROLES?.PlantSCMOperator) ? "approved" : "pending");
    const [selectedAsnData, setSelectedAsnData] = useState();
    const [asnList, setasnList] = useState([]);
    const [bulkApproveAsnCorrection, setbulkApproveAsnCorrection] = useState();
    const [tabValueMaterial, setTabValueMaterial] = useState(state?.tabValueMaterial ?? "RawBamboo");
    const [isApiCalled, setIsApiCalled] = useState(false);
    const [comment, setComment] = useState("");

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [confirmOpen2, setConfirmOpen2] = useState(false);
    const handleConfirmOpen2 = () => setConfirmOpen2(true);
    const handleConfirmClose2 = () => setConfirmOpen2(false);

    const handleTabChange = (_e, newValue) => {
        setTabValue(newValue);
        setTabValueMaterial("RawBamboo");
        setasnList([])
    };

    const handleMaterialTabChange = (_e, newValue) => {
        setTabValueMaterial(newValue);
        setasnList([])
    };

    useEffect(() => {
        getAsnCorrectionDetails(tabValue, tabValueMaterial);
    }, [tabValue, tabValueMaterial]);

    const onViewDetails = (cellValues) => {
        setSelectedAsnData(cellValues)
        navigate('./asnCorrectionViewDetails', {
            state: { selectedRow: cellValues, tabValue: tabValue, tabValueMaterial: tabValueMaterial, useCorrectionApi: tabValue === "pending", pageName: "asnCorrectionApproval" }
        });
    }


    const getAsnCorrectionDetails = (value, materialType) => {
        const data = {
            roleType: localStorage.getItem("role") || "",
            materialType,
            ...(value === "rejected"
                ? { isRequestRejected: true }
                : { isRequestApproved: value !== "pending" }),
        };

        const headers = { Authorization: "Bearer " + getLocalStorageItem("id_token") };

        loaderService.showLoader();
        apiClient
            .post(GET_ASN_CORRECTION_LIST, data, { headers })
            .then((res) => setAsnDetails(res.data.asnList || []))
            .catch((err) => {
                console.error(err);
                toast.error(err?.message || "Failed to load ASN list");
            })
            .finally(() => loaderService.hideLoader());
    };

    const columns = [
        { field: 'asnNo', headerName: 'ASN ID#', width: 120 },
        { field: 'consignmentNo', headerName: 'Consignment No', width: 130 },
        { field: 'challanNo', headerName: 'Delivery Challan Number', width: 180 },
        { field: 'grnNo', headerName: 'GRN Number', width: 150 },
        { field: 'sesNo', headerName: 'SES Number', width: 150 },
        // { field: 'poNumber', headerName: 'PO Number', width: 150 },
        {
            field: 'stakeholderSourceUrn', headerName: 'Source URN', width: 150,
            renderCell: (params) => {
                return (
                    <>{params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceUrn}</>
                );
            },
            valueGetter: (params) => params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceUrn
        },
        {
            field: 'stakeholderSourceName', headerName: 'Source Name', width: 180,
            renderCell: (params) => {
                return (
                    <>{params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceName}</>
                );
            },
            valueGetter: (params) => params?.row?.asnPoDetailsList?.[0]?.stakeholderSourceName
        },
        { field: 'consignmentDestinationStakeholderUrn', headerName: 'Destination URN', width: 150 },
        {
            field: 'consignmentDestinationName', headerName: 'Destination Name', width: 200,
            renderCell: (params) => {
                return (
                    <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                        {params.value}
                    </div>
                )
            },
            valueGetter: (params) => params.value
        },
        { field: 'consignmentStatus', headerName: 'Consignment Status', width: 220 },
        { field: 'asnStatus', headerName: 'ASN Status', width: 220 },
        {
            field: 'asnDate', headerName: 'ASN Date', width: 150,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        // {
        //     field: 'pickupNetWeight', headerName: 'ASN Quantity', width: 120,
        // },
        {
            field: 'lastComment', headerName: 'Previous Comment', width: 220, hide: tabValue === "pending"
        },
        {
            field: 'Action', width: 150,
            renderCell: (cellValues) => {
                return (
                    <Tooltip title="View">
                        <IconButton
                            // disabled={cellValues?.row?.grnNo && cellValues?.row?.isSentBackForAsnCorrection !== true}
                            color="primary"
                            onClick={() => onViewDetails(cellValues.row)}
                        >
                            <ViewIcon />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
    ];

    const onConfirmApprove = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await toApproveBulk(true);
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen(false);
            setIsApiCalled(false);
        }
    }

    const onApproveButtonClick = (e) => {
        if(!comment) {
            toast.error("Please enter comment")
        }
        else handleConfirmOpen();
    }

    const toApproveBulk = (approval) => {
        const asnNumberList = asnList.map((asnNo) => ({
            ansNumber: asnNo,
            comment: comment
        }));

        loaderService.showLoader();
        apiClient
            .post(APPROVE_ASN_CORRECTION, {
                asnNumberList,
                isASNCorrectionApproved: approval,
                asnCorrectionApprovedBy: localStorage.getItem('InspectorEmail')
            }, {
                headers: { Authorization: 'Bearer ' + getLocalStorageItem('id_token') }
            })
            .then((response) => {
                setbulkApproveAsnCorrection(response.data);
                getAsnCorrectionDetails(tabValue, tabValueMaterial);
                setComment(""); // Clear comment on success
                loaderService.hideLoader();
            })
            .catch((error) => {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (bulkApproveAsnCorrection) {
            if (bulkApproveAsnCorrection.isSuccess === true) {
                toast.success(bulkApproveAsnCorrection?.message)
                setasnList([])
            }
            else {
                toast.error(bulkApproveAsnCorrection?.message ? bulkApproveAsnCorrection?.message : "Error")
            }
        }
    }, [bulkApproveAsnCorrection]);

    const onConfirmReject = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await toRejectBulk();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen2(false);
            setIsApiCalled(false);
        }
    }

    const onRejectButtonClick = (e) => {
        if(!comment) {
            toast.error("Please enter comment")
        }
        else handleConfirmOpen2();
    }

    const toRejectBulk = () => {
        const asnNumberList = asnList.map((asnNo) => ({
            ansNumber: asnNo,
            comment: comment
        }));

        loaderService.showLoader();
        apiClient
            .post(REJECT_ASN_CORRECTION, {
                asnNumberList,
                isASNCorrectionRejected: true,
                asnCorrectionRejectedBy: localStorage.getItem('InspectorEmail')
            }, {
                headers: { Authorization: 'Bearer ' + getLocalStorageItem('id_token') }
            })
            .then((response) => {
                setbulkApproveAsnCorrection(response.data);
                getAsnCorrectionDetails(tabValue, tabValueMaterial);
                setComment(""); // Clear comment on success
                loaderService.hideLoader();
            })
            .catch((error) => {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT06</p>}
                <Stack direction={{ xs: 'column', md: 'row' }} mb={2} justifyContent="space-between" alignItems="center">
                    <Typography variant="h4">ASN Correction Approval</Typography>

                </Stack>
                <Card>
                    <TabContext value={tabValue}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: "whitesmoke" }}>
                            <TabList onChange={handleTabChange}>
                                {getLocalStorageItem('role') === PIT_ROLES?.PitScmUser || getLocalStorageItem('role') === PIT_ROLES?.PlantSCMOperator ? null : <Tab label="Pending ASN Correction" value="pending" />}
                                <Tab label="Approved ASN Correction" value="approved" />
                                <Tab label="Rejected ASN Correction" value="rejected" />
                            </TabList>
                        </Box>
                        <TabPanel value="pending" hidden={getLocalStorageItem('role') === PIT_ROLES?.PitScmUser || getLocalStorageItem('role') === PIT_ROLES?.PlantSCMOperator}>
                            <Card>
                                <TabContext key={`inner-${tabValue}`} value={tabValueMaterial}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: "whitesmoke" }}>
                                        <TabList onChange={handleMaterialTabChange} >
                                            <Tab label='Pending RB List' value="RawBamboo" />
                                            <Tab label='Pending CB List' value="ChipBamboo" />
                                        </TabList>
                                    </Box>
                                    <TabPanel value="RawBamboo" >
                                        <Box style={{ height: 500, width: '100%' }}>
                                            {
                                                asnDetails &&
                                                <DataGrid rows={asnDetails}
                                                    columns={columns}
                                                    pageSize={10}
                                                    checkboxSelection
                                                    components={{ Toolbar: QuickSearchToolbar }}
                                                    onSelectionModelChange={(newSelection) => {
                                                        setasnList(newSelection.map(row => {
                                                            let asnNo = ""
                                                            asnDetails.forEach(item => {

                                                                if (row === item.id) {
                                                                    asnNo = item.asnNo;
                                                                }

                                                            })
                                                            return asnNo;
                                                        }));
                                                    }}
                                                />
                                            }
                                        </Box>
                                    </TabPanel>
                                    <TabPanel value="ChipBamboo">
                                        <Box style={{ height: 500, width: '100%' }}>
                                            {
                                                asnDetails &&
                                                <DataGrid rows={asnDetails}
                                                    columns={columns}
                                                    pageSize={10}
                                                    checkboxSelection
                                                    components={{ Toolbar: QuickSearchToolbar }}
                                                    onSelectionModelChange={(newSelection) => {
                                                        setasnList(newSelection.map(row => {
                                                            let asnNo = ""
                                                            asnDetails.forEach(item => {

                                                                if (row === item.id) {
                                                                    asnNo = item.asnNo;
                                                                }

                                                            })
                                                            return asnNo;
                                                        }));
                                                    }}
                                                />
                                            }
                                        </Box>
                                    </TabPanel>
                                </TabContext>
                            </Card>
                        </TabPanel>
                        <TabPanel value="approved">
                            <Card>
                                <TabContext key={`inner-${tabValue}`} value={tabValueMaterial}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: "whitesmoke" }}>
                                        <TabList onChange={handleMaterialTabChange} >
                                            <Tab label='Approved RB List' value="RawBamboo" />
                                            <Tab label='Approved CB List' value="ChipBamboo" />
                                        </TabList>
                                    </Box>
                                    <TabPanel value="RawBamboo" >
                                        <Box style={{ height: 500, width: '100%' }}>
                                            {
                                                asnDetails &&
                                                <DataGrid rows={asnDetails}
                                                    getRowHeight={() => 'auto'}
                                                    sx={{
                                                        [`& .${gridClasses.cell}`]: {
                                                            py: 1,
                                                        },
                                                        '& .MuiDataGrid-cell': {
                                                            whiteSpace: 'normal !important',
                                                            wordWrap: 'break-word !important',
                                                        },
                                                    }}
                                                    // getRowId={(row) => row.stakeholderURN}
                                                    columns={columns}
                                                    pageSize={10}
                                                    components={{ Toolbar: QuickSearchToolbar }}
                                                />
                                            }
                                        </Box>
                                    </TabPanel>
                                    <TabPanel value="ChipBamboo">
                                        <Box style={{ height: 500, width: '100%' }}>
                                            {
                                                asnDetails &&
                                                <DataGrid rows={asnDetails}
                                                    getRowHeight={() => 'auto'}
                                                    sx={{
                                                        [`& .${gridClasses.cell}`]: {
                                                            py: 1,
                                                        },
                                                        '& .MuiDataGrid-cell': {
                                                            whiteSpace: 'normal !important',
                                                            wordWrap: 'break-word !important',
                                                        },
                                                    }}
                                                    // getRowId={(row) => row.stakeholderURN}
                                                    columns={columns}
                                                    pageSize={10}
                                                    components={{ Toolbar: QuickSearchToolbar }}
                                                />
                                            }
                                        </Box>
                                    </TabPanel>
                                </TabContext>
                            </Card>

                        </TabPanel>
                        <TabPanel value="rejected">
                            <Card>
                                <TabContext key={`inner-${tabValue}`} value={tabValueMaterial}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: "whitesmoke" }}>
                                        <TabList onChange={handleMaterialTabChange} >
                                            <Tab label='Rejected RB List' value="RawBamboo" />
                                            <Tab label='Rejected CB List' value="ChipBamboo" />
                                        </TabList>
                                    </Box>
                                    <TabPanel value="RawBamboo" >
                                        <Box style={{ height: 500, width: '100%' }}>
                                            {
                                                asnDetails &&
                                                <DataGrid rows={asnDetails}
                                                    getRowHeight={() => 'auto'}
                                                    sx={{
                                                        [`& .${gridClasses.cell}`]: {
                                                            py: 1,
                                                        },
                                                        '& .MuiDataGrid-cell': {
                                                            whiteSpace: 'normal !important',
                                                            wordWrap: 'break-word !important',
                                                        },
                                                    }}
                                                    // getRowId={(row) => row.stakeholderURN}
                                                    columns={columns}
                                                    pageSize={10}
                                                    components={{ Toolbar: QuickSearchToolbar }}
                                                />
                                            }
                                        </Box>
                                    </TabPanel>
                                    <TabPanel value="ChipBamboo">
                                        <Box style={{ height: 500, width: '100%' }}>
                                            {
                                                asnDetails &&
                                                <DataGrid rows={asnDetails}
                                                    getRowHeight={() => 'auto'}
                                                    sx={{
                                                        [`& .${gridClasses.cell}`]: {
                                                            py: 1,
                                                        },
                                                        '& .MuiDataGrid-cell': {
                                                            whiteSpace: 'normal !important',
                                                            wordWrap: 'break-word !important',
                                                        },
                                                    }}
                                                    // getRowId={(row) => row.stakeholderURN}
                                                    columns={columns}
                                                    pageSize={10}
                                                    components={{ Toolbar: QuickSearchToolbar }}
                                                />
                                            }
                                        </Box>
                                    </TabPanel>
                                </TabContext>
                            </Card>

                        </TabPanel>
                        <Box sx={{ p: 3, borderTop: '1px solid #e0e0e0', bgcolor: '#fcfcfc' }} hidden={getLocalStorageItem('role') === PIT_ROLES?.PitScmUser || getLocalStorageItem('role') === PIT_ROLES?.PlantSCMOperator}>
                            <Grid container spacing={2} alignItems="flex-end">
                                <Grid item xs={12} md={8}>
                                    <TextField
                                        fullWidth
                                        required
                                        label="Comment"
                                        variant="outlined"
                                        size="small"
                                        multiline
                                        rows={2}
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                        placeholder="Enter your remarks here..."
                                    />
                                </Grid>

                                <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                    <Button
                                        variant="contained"
                                        disabled={tabValue === "approved" || asnList.length === 0}
                                        onClick={onApproveButtonClick}
                                        startIcon={<ApproveIcon />}
                                    >
                                        Approve
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        disabled={tabValue === "approved" || asnList.length === 0}
                                        onClick={onRejectButtonClick}
                                        startIcon={<CancelIcon />}
                                    >
                                        Reject
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>

                    </TabContext>
                </Card>
            </Container>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Approve ASN Correction" />
            <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmReject} onClose={handleConfirmClose2} action="Reject ASN Correction" />

        </>
    );
}
export default AsnCorrectionApproval;
